import TabFeed from './TabFeed';

export default TabFeed;
